import React from 'react'
// import GoldQuoteIcon from 'src/images/icons/GoldQuoteIcon'
import GoldQuoteIcon from 'src/images/svgs/icons/GoldQuoteIcon.svg'
import * as Styles from './quoteBlock.module.scss'

export type QuoteBlockContent = {
  anchor?: string
  quote?: string
  name?: string
  title?: string
}

type Props = {
  content: QuoteBlockContent
}

const QuoteBlock = ({ content }: Props) => {
  const { anchor, quote, name, title } = content
  return (
    <section id={anchor} className={Styles.quoteBlock}>
      <GoldQuoteIcon className={Styles.icon} />
      <blockquote className={Styles.quote}>{quote}</blockquote>
      <div className={Styles.attribution}>
        <span className={Styles.name}>{name}</span>
        {title && <span className={Styles.title}>, {title}</span>}
      </div>
    </section>
  )
}

export default QuoteBlock
